module.exports = __webpack_public_path__ + "img/logo.76ff3e2d.png";